import { DataService } from '../../../services/data_service';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { ImportEmissionsfaktoren } from './functions/ImportEmissionsfaktoren';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { saveInChunks } from '../kennzahlen/saveInChunks';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

interface EmissionsfaktorenImportProps extends React.ClassAttributes<any> {
    data: any;
    dataImport: string;
    entity: string;
    onCancel(): void;
    onSaveDone?(): void;
    params: any;
}

interface EmissionsfaktorenImportState extends React.ClassAttributes<any> {
    dataTable: any[];
    filterError: boolean;
    filterInsert: boolean;
    isImporting: boolean;
}

 export class EmissionsfaktorenImport extends React.Component<EmissionsfaktorenImportProps, EmissionsfaktorenImportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dataTable: null,
            filterError: false,
            filterInsert: false,
            isImporting: false
        };
        this.customFormatter = this.customFormatter.bind(this);
        this.onDataImported = this.onDataImported.bind(this);
        this.onDataImporting = this.onDataImporting.bind(this);
        this.preFilter = this.preFilter.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private autoReferences: any = {};
    private bundle: any = {};
    private data: any[] = [];
    private errors: number = 0;
    private rowsInsert: number = 0;
    private styleFilterButton: React.CSSProperties = {
        fontSize: 12, height: 28, marginTop: 2, marginRight: 2, padding: '0 3px', display: 'flex', alignItems: 'center', cursor: 'pointer'
    };

    componentDidMount(): void {
        this.init();
    }

    autoCreateReferences(callback: () => void): void {
        const autoReferences: string[] = Object.keys(this.autoReferences);

        if (!autoReferences.length && typeof callback === 'function') {
            callback();
        }

        autoReferences.forEach((key: string) => {
            this.processReferences(key, (data: string[]) => {
                this.setReferences(data, key, () => {
                    this.setReferenceTids(key, () => typeof callback === 'function' ? callback() : null);
                });
            });
        });
    }

    customFormatter(field: string, value: any, data: any): any {
        const dataMeta: any = (data._meta || {})._row || (data._meta || {})[field] || {};
        let backgroundColor: string = null;
        let color: string = null;

        if (dataMeta.type === 'error') {
            backgroundColor = '#edb6ab';
            color = '#bf4329';
            value = value === '' && typeof data[field] !== 'undefined' ? data[field] : value;
        } else if (dataMeta.type === 'insert') {
            backgroundColor = '#dcf1d8';
            color = '#34812c';
        } else {
            return value;
        }

        return (
            <div
                style={{
                    color, backgroundColor, height: '100%', outline: `2px solid ${backgroundColor}`,
                    ...(dataMeta.info && { cursor: 'help' })
                }}
                title={dataMeta.info ? dataMeta.info : ''}
            >
                {value}
            </div>
        );
    }

    getArrayDiff(data: string[], data2: string[]): string[] {
        return (data || []).filter((value: string) => !(data2 || []).includes(value));
    }

    init(): void {
        const Import: any = new ImportEmissionsfaktoren(
            this.props.dataImport, 2, this.props.entity, this.props.data, this.props.params, this.props.onCancel
        );
        const dataTable: any[] = Import.getDataTable() || [];
        this.autoReferences = Import.getAutoReferences() || {};
        this.bundle = Import.getBundle() || {};
        this.data = Import.getData() || [];
        this.errors = Import.getNumberErrors() || 0;
        this.rowsInsert = Import.getNumberRowsInsert() || 0;
        console.info('import:', this.data, this.autoReferences);
        this.setState({ dataTable });
    }

    onDataImported(success: boolean): void {
        if (success) {
            alert(i18n('Die Datensätze wurden erfolgreich importiert.', 'sys'));
            this.triggerService.fire('admin_reload', this.props.entity);
        } else {
            alert(i18n('Die Datensätze konnten nicht importiert werden!', 'sys'));
        }
        this.setState({ isImporting: false }, () => typeof this.props.onSaveDone === 'function' && this.props.onSaveDone());
    }

    onDataImporting(callback: (success: boolean) => void): void {
        this.setState({ isImporting: true }, () => {
            this.autoCreateReferences(() => {
                saveInChunks(
                    this.data || [], this.dataService, this.props.entity, IDs.MOD_ETOOL_ADMIN,
                    () => typeof callback === 'function' ? callback(true) : null
                );
            });
        });
    }

    preFilter(data: any[]): any[] {
        return data.filter((item: any) =>
            (!this.state.filterInsert && !this.state.filterError) || Object.values(item._meta || {}).findIndex((meta: any) =>
                (this.state.filterInsert && meta.type === 'insert') || (this.state.filterError && meta.type === 'error')
            ) !== -1
        );
    }

    processReferences(key: string, callback: (data: string[]) => void): void {
        const { entity, field, index, module, values } = this.autoReferences[key] || {};
        const curValues: string[] = Array.from(values || []);

        if (!curValues.length || !entity || !module || !index || !field) {
            return typeof callback === 'function' ? callback([]) : null;
        }
        this.dataService.loadData(
            entity, {}, { fieldList: `${index}, ${field}` }, (obj: any) => {
                if (typeof callback === 'function') {
                    const data: any[] = (this.getArrayDiff(curValues, (obj[entity] || []).map((item: any) => item[field])))
                        .map((value: string) => { return { [index]: 0, [field]: value }; });
                    callback(data);
                }
            },
            module
        );
    }

    render(): JSX.Element {
        if (!this.state.dataTable) {
            return null;
        }

        return <>
            <WFormsTableWrapper
                key={`import_emissionsfaktoren_${this.state.filterError}_${this.state.filterInsert}`}
                entity={this.props.entity}
                module={IDs.MOD_ETOOL_ADMIN}
                data={this.state.dataTable}
                bundle={this.bundle}
                actions={[]}
                hideExport
                externalHeaderElements={[
                    this.renderCancelButton(), this.renderSaveButton(), this.renderFilterInsertButton(), this.renderFilterErrorButton()
                ]}
                customClass='Custom-ETA'
                formLayout='flowV2'
                customFormatter={this.customFormatter}
                preFilterFunction={this.preFilter}
            />
            {this.state.isImporting && <WSpinner label={i18n('Senden', 'sys')} />}
        </>;
    }

    renderCancelButton(): JSX.Element {
        return (
            <WActionButton
                label={i18n('Import abbrechen', 'sys')}
                insideText={i18n('Import abbrechen', 'sys')}
                key='cancel'
                action='cancel'
                onAction={() => this.props.onCancel()}
            />
        );
    }

    renderFilterErrorButton(): JSX.Element {
        if (!this.errors) {
            return null;
        }
        const style: React.CSSProperties = { ...this.styleFilterButton, color: '#bf4329', backgroundColor: '#edb6ab' };

        return (
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.filterError}
                    onChange={(event: any) => this.setState({ filterError: event.target.checked })}
                />
                {`Fehler (${this.errors})`}
            </label>
        );
    }

    renderFilterInsertButton(): JSX.Element {
        if (!this.rowsInsert || this.rowsInsert === this.state.dataTable.length) {
            return null;
        }
        const style: React.CSSProperties = { ...this.styleFilterButton, color: '#34812c', backgroundColor: '#dcf1d8' };

        return (
            <label style={style}>
                <input
                    type='checkbox'
                    checked={this.state.filterInsert}
                    onChange={(event: any) => this.setState({ filterInsert: event.target.checked })}
                />
                Neu
            </label>
        );
    }

    renderSaveButton(): JSX.Element {
        const rows: number = (this.data || []).length;

        return (
            <WActionButton
                label={i18n('Speichern', 'sys')}
                insideText={i18n('Speichern', 'sys')}
                key='save'
                action='save'
                styleProps={ !rows && { backgroundColor: 'lightgray', cursor: 'not-allowed' } }
                indicatorFullNumber
                indicatorValue={rows}
                indicatorColor={rows ? '#0a0' : '#aaa'}
                disabled={!rows}
                onAction={() => this.onDataImporting(this.onDataImported)}
            />
        );
    }

    setReferenceTids(key: string, callback: () => void): void {
        const { entity, field, index, module } = this.autoReferences[key] || {};

        if (!key || !entity || !module || !index || !field) {
            return typeof callback === 'function' ? callback() : null;
        }

        this.dataService.loadData(
            entity, {}, { fieldList: `${index}, ${field}` }, (obj: any) => {
                if (typeof callback === 'function') {
                    const items: any = {};
                    (obj[entity] || []).forEach((item: any) => items[item[field]] = item[index]);
                    (this.data || []).forEach((item: any) => item[key] = items[item[key]] || null);
                    callback();
                }
            },
            module
        );
    }

    setReferences(data: any[], key: string, callback: () => void): void {
        const { entity, module } = this.autoReferences[key] || {};

        if (!(data || []).length || !key || !entity || !module) {
            return typeof callback === 'function' ? callback() : null;
        }
        saveInChunks(
            data, this.dataService, entity, module,
            () => {
                this.triggerService.fire('admin_reload', entity);
                return typeof callback === 'function' ? callback() : null;
            }
        );
    }
}
